import { actionTypes } from '../types'

const initState = {};

const authenticationReducers = (state = initState, action) => {

    switch (action.type) {
        case actionTypes.GET_USER_INFO:
            {
                let newState;
                newState = {
                    ...state,
                    ...action.payload.consolidatedRespData
                }
                return newState;
            }
        case actionTypes.NAME_CHANGE: {
            let newState;
            newState = {
                ...state,
                nameInState: action.payload.resp.data.name
            }
            return newState;
        }
        case actionTypes.GET_FUTURE_TEE_TICKETS: {
            let newState;
            newState = {
                ...state,
                tickets: action.payload.tickets
            }
            console.log(newState)
            return newState;
        }

        /*case actionTypes.GET_PAPER_INFO:
            {
                let newState;
                newState = {
                    ...state,
                    ...action.payload.paperInfo
                }
                return newState;
            }
        case actionTypes.GET_REGISTRATION_INFO:
            {
                let newState;
                newState = {
                    ...state,
                    memberShip: action.payload.regInfo.registrationTitle
                }
                return newState;
            } */
        case actionTypes.ERROR: {
            let newState;
            newState = {
                ...state,
                errorMessage: action.payload

            }
            return newState;
        }

        default:
            {
                return state
            }

    }

}

export default authenticationReducers
